import React from 'react';
import Graphic from '../../objects/graphicsLibrary/graphic';
import {
    Box,
    Card,
    CardActionArea,
    makeStyles,
    Tooltip,
    Typography,
} from '@material-ui/core';

import { Skeleton } from '@material-ui/lab';
import transparentImg from '../../img/transparent.png';
import clsx from 'clsx';
import { useTypedSelector } from '../../shared/hooks/useTypedSelector';
import usePrices from '../../shared/hooks/usePrices';

interface Props {
    item: Graphic;
    index: number;
    handleShowGraphicDetail: (item: Graphic) => void;
}

const useStyles = makeStyles((theme) => ({
    skeletonImg: {
        opacity: 0.1,
        backgroundImage: `url(${transparentImg})`,
    },
    root: {
        height: 100,
        width: 100,
        backgroundImage: `url(${transparentImg})`,
    },
    centered: {
        height: 100,
        width: 100,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    media: {
        maxHeight: 100,
        maxWidth: 100,
    },
    hidden: {
        display: 'none',
    },
}));

const ListItem: React.FC<Props> = (props) => {
    const classes = useStyles();

    const { item, index, handleShowGraphicDetail } = props;
    const [loaded, setLoaded] = React.useState<boolean>(false);
    const { data: productData } = useTypedSelector(
        (state) => state.od.loadProduct
    );
    const { displayPrice } = usePrices(productData?.currency);

    return (
        <Box key={index} marginRight={2} my={1}>
            {item ? (
                <>
                    <Skeleton
                        className={clsx(
                            classes.skeletonImg,
                            loaded && classes.hidden
                        )}
                        variant="rect"
                        width={100}
                        height={100}
                    />
                    <Card
                        className={clsx(
                            classes.root,
                            !loaded && classes.hidden
                        )}
                    >
                        <CardActionArea className={classes.centered}>
                            <Tooltip
                                title={
                                    <React.Fragment>
                                        <Typography color="inherit">
                                            {item.getNameOrSource()}
                                        </Typography>
                                        {item.getDescription() && (
                                            <p>{item.getDescription()}</p>
                                        )}
                                        {item.getPrice() !== 0 && (
                                            <p>
                                                {displayPrice(
                                                    productData
                                                        ? item.getPrice() *
                                                              (1 +
                                                                  productData.tax)
                                                        : item.getPrice()
                                                )}
                                            </p>
                                        )}
                                    </React.Fragment>
                                }
                            >
                                <img
                                    className={classes.media}
                                    src={item.getSmallImageUrl()}
                                    onLoad={() => {
                                        setLoaded(true);
                                    }}
                                    alt={item.getNameOrSource()}
                                    onClick={() =>
                                        handleShowGraphicDetail(item)
                                    }
                                />
                            </Tooltip>
                        </CardActionArea>
                    </Card>
                </>
            ) : (
                <Skeleton
                    className={classes.skeletonImg}
                    variant="rect"
                    width={100}
                    height={100}
                />
            )}
        </Box>
    );
};

export default ListItem;
